// Generated by @speria-jp/json-schema-validator-gen
// https://github.com/speria-jp/json-schema-validator-gen
// Do not edit manually
// ============================================================================
// Validation Types (auto-generated)
// ============================================================================

type ValidationResult<T> =
  | { success: true; data: T }
  | { success: false; issues: ValidationIssue[] };

interface ValidationIssue {
  code: ValidationIssueCode;
  path: (string | number)[];
  message: string;
  expected: string;
  received: string;
}

type ValidationIssueCode =
  | "invalid_type"
  | "invalid_value"
  | "too_small"
  | "too_big"
  | "invalid_string"
  | "not_integer"
  | "not_unique"
  | "unrecognized_key"
  | "missing_key";

interface ValidationOptions {
  abortEarly?: boolean;
}

// ============================================================================
// Validation Helpers (auto-generated)
// ============================================================================

function _getType(value: unknown): string {
  if (value === null) return "null";
  if (Array.isArray(value)) return "array";
  return typeof value;
}

function _invalidType(issues: ValidationIssue[], path: (string | number)[], expected: string, value: unknown): void {
  const received = _getType(value);
  issues.push({ code: "invalid_type", path, message: `Expected ${expected}, received ${received}`, expected, received });
}

function _missingKey(issues: ValidationIssue[], path: (string | number)[], key: string): void {
  const expected = `object with required property "${key}"`;
  const received = `object without property "${key}"`;
  issues.push({ code: "missing_key", path, message: `Expected ${expected}, received ${received}`, expected, received });
}

function _tooSmall(issues: ValidationIssue[], path: (string | number)[], expected: string, received: string): void {
  issues.push({ code: "too_small", path, message: `Expected ${expected}, received ${received}`, expected, received });
}

function _tooBig(issues: ValidationIssue[], path: (string | number)[], expected: string, received: string): void {
  issues.push({ code: "too_big", path, message: `Expected ${expected}, received ${received}`, expected, received });
}

function _invalidString(issues: ValidationIssue[], path: (string | number)[], expected: string, received: string): void {
  issues.push({ code: "invalid_string", path, message: `Expected ${expected}, received ${received}`, expected, received });
}

function _invalidValue(issues: ValidationIssue[], path: (string | number)[], expected: string, received: string): void {
  issues.push({ code: "invalid_value", path, message: `Expected ${expected}, received ${received}`, expected, received });
}

function _notInteger(issues: ValidationIssue[], path: (string | number)[], value: number): void {
  issues.push({ code: "not_integer", path, message: `Expected integer, received ${value}`, expected: "integer", received: String(value) });
}

function _notUnique(issues: ValidationIssue[], path: (string | number)[]): void {
  issues.push({ code: "not_unique", path, message: "Expected array with unique items, received array with duplicate items", expected: "array with unique items", received: "array with duplicate items" });
}

function _unrecognizedKey(issues: ValidationIssue[], path: (string | number)[], expected: string, key: string): void {
  issues.push({ code: "unrecognized_key", path, message: `Expected ${expected}, received ${key}`, expected, received: key });
}


export type DocumentConfigSchema = {
    meta: {
        appId: "document";
        version: "karte/documentSchema/20250827";
    };
    data: {
        name: string;
        scope: "customer_visit" | "customer" | "shop";
        template: {
            body: string;
        };
    };
};


export function validateDocumentConfigSchema(value: unknown, options?: ValidationOptions): ValidationResult<DocumentConfigSchema> {
    const issues: ValidationIssue[] = [];
    const abortEarly = options?.abortEarly ?? false;
    if (!(typeof value === "object" && value !== null && !Array.isArray(value))) {
        _invalidType(issues, [], "object", value);
        if (abortEarly)
            return { success: false, issues };
    }
    else {
        if (!("meta" in value)) {
            _missingKey(issues, [], "meta");
            if (abortEarly)
                return { success: false, issues };
        }
        if (!("data" in value)) {
            _missingKey(issues, [], "data");
            if (abortEarly)
                return { success: false, issues };
        }
        if ("meta" in value) {
            if (!(typeof value.meta === "object" && value.meta !== null && !Array.isArray(value.meta))) {
                _invalidType(issues, ["meta"], "object", value.meta);
                if (abortEarly)
                    return { success: false, issues };
            }
            else {
                if (!("appId" in value.meta)) {
                    _missingKey(issues, ["meta"], "appId");
                    if (abortEarly)
                        return { success: false, issues };
                }
                if (!("version" in value.meta)) {
                    _missingKey(issues, ["meta"], "version");
                    if (abortEarly)
                        return { success: false, issues };
                }
                if ("appId" in value.meta) {
                    if (value.meta.appId !== "document") {
                        _invalidValue(issues, ["meta", "appId"], "\"document\"", JSON.stringify(value.meta.appId));
                        if (abortEarly)
                            return { success: false, issues };
                    }
                }
                if ("version" in value.meta) {
                    if (value.meta.version !== "karte/documentSchema/20250827") {
                        _invalidValue(issues, ["meta", "version"], "\"karte/documentSchema/20250827\"", JSON.stringify(value.meta.version));
                        if (abortEarly)
                            return { success: false, issues };
                    }
                }
                for (const key1 in value.meta) {
                    if (!["appId", "version"].includes(key1)) {
                        _unrecognizedKey(issues, ["meta", key1], `one of known properties (${["appId", "version"].join(", ")})`, key1);
                        if (abortEarly)
                            return { success: false, issues };
                    }
                }
            }
        }
        if ("data" in value) {
            if (!(typeof value.data === "object" && value.data !== null && !Array.isArray(value.data))) {
                _invalidType(issues, ["data"], "object", value.data);
                if (abortEarly)
                    return { success: false, issues };
            }
            else {
                if (!("name" in value.data)) {
                    _missingKey(issues, ["data"], "name");
                    if (abortEarly)
                        return { success: false, issues };
                }
                if (!("scope" in value.data)) {
                    _missingKey(issues, ["data"], "scope");
                    if (abortEarly)
                        return { success: false, issues };
                }
                if (!("template" in value.data)) {
                    _missingKey(issues, ["data"], "template");
                    if (abortEarly)
                        return { success: false, issues };
                }
                if ("name" in value.data) {
                    if (!(typeof value.data.name === "string")) {
                        _invalidType(issues, ["data", "name"], "string", value.data.name);
                        if (abortEarly)
                            return { success: false, issues };
                    }
                }
                if ("scope" in value.data) {
                    if (!(["customer_visit", "customer", "shop"] as unknown[]).includes(value.data.scope)) {
                        _invalidValue(issues, ["data", "scope"], "\"customer_visit\" | \"customer\" | \"shop\"", JSON.stringify(value.data.scope));
                        if (abortEarly)
                            return { success: false, issues };
                    }
                }
                if ("template" in value.data) {
                    if (!(typeof value.data.template === "object" && value.data.template !== null && !Array.isArray(value.data.template))) {
                        _invalidType(issues, ["data", "template"], "object", value.data.template);
                        if (abortEarly)
                            return { success: false, issues };
                    }
                    else {
                        if (!("body" in value.data.template)) {
                            _missingKey(issues, ["data", "template"], "body");
                            if (abortEarly)
                                return { success: false, issues };
                        }
                        if ("body" in value.data.template) {
                            if (!(typeof value.data.template.body === "string")) {
                                _invalidType(issues, ["data", "template", "body"], "string", value.data.template.body);
                                if (abortEarly)
                                    return { success: false, issues };
                            }
                        }
                        for (const key2 in value.data.template) {
                            if (!["body"].includes(key2)) {
                                _unrecognizedKey(issues, ["data", "template", key2], `one of known properties (${["body"].join(", ")})`, key2);
                                if (abortEarly)
                                    return { success: false, issues };
                            }
                        }
                    }
                }
                for (const key3 in value.data) {
                    if (!["name", "scope", "template"].includes(key3)) {
                        _unrecognizedKey(issues, ["data", key3], `one of known properties (${["name", "scope", "template"].join(", ")})`, key3);
                        if (abortEarly)
                            return { success: false, issues };
                    }
                }
            }
        }
        for (const key4 in value) {
            if (!["meta", "data"].includes(key4)) {
                _unrecognizedKey(issues, [key4], `one of known properties (${["meta", "data"].join(", ")})`, key4);
                if (abortEarly)
                    return { success: false, issues };
            }
        }
    }
    if (issues.length > 0) {
        return { success: false, issues };
    }
    return { success: true, data: value as DocumentConfigSchema };
}
export function unsafeValidateDocumentConfigSchema(value: unknown): DocumentConfigSchema {
    const result = validateDocumentConfigSchema(value, { abortEarly: true });
    if (!result.success) {
        throw new Error("Validation failed: value is not DocumentConfigSchema");
    }
    return result.data;
}
